// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__hLwWa","links":"Footer_links__Lv+h6","linksGroup":"Footer_linksGroup__b9r3p","contacts":"Footer_contacts__OchCt"};